/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var InputType;
(function (InputType) {
    InputType["TEXT_AREA"] = "TEXT_AREA";
    InputType["TEXT_FIELD"] = "TEXT_FIELD";
    InputType["SINGLE_SELECT"] = "SINGLE_SELECT";
    InputType["MULTI_SELECT"] = "MULTI_SELECT";
    InputType["CHECKBOX"] = "CHECKBOX";
})(InputType || (InputType = {}));
